import { render, staticRenderFns } from "./DashboardFeedbackSummaryList.vue?vue&type=template&id=6d8c9172&scoped=true&"
import script from "./DashboardFeedbackSummaryList.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbackSummaryList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbackSummaryList.vue?vue&type=style&index=0&id=6d8c9172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8c9172",
  null
  
)

export default component.exports